import AssessmentDial from '@static/images/assessment/assessment-dial.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './AssessmentGauge.module.scss';
import { getGaugeArrowStyle, getGaugePosition } from './assessment-gauge-utils';

export interface AssessmentGaugeProps {
  gaugeValue: number;
}

export const AssessmentGauge = ({ gaugeValue }: AssessmentGaugeProps) => {
  const { t } = useTranslation('widget');

  return (
    <div className={styles.qualityGaugeWrapper}>
      <AssessmentDial className={styles.qualityGaugeBackground} />
      <span
        className={styles.gaugeArrow}
        data-testid="verdict-arrow"
        style={getGaugeArrowStyle(gaugeValue)}
      />
      <span
        className={styles.gaugeVerdictWrapper}
        data-testid="verdict-wrapper"
        style={{ color: getGaugePosition(gaugeValue).color }}
      >
        {gaugeValue}
        <div className={styles.gaugeVerdict} data-testid="verdict-value">
          {
            /* i18next-extract-mark-context-next-line ["1", "2", "3", "4", "5", "6", "7", "8"] */
            t('widget:assessment.evaluations.stars', {
              context: String(gaugeValue),
            })
          }
        </div>
      </span>
    </div>
  );
};
